import Vue from 'vue'
import * as MutationTypes from '@/store/mutation-types'

export default {
    [MutationTypes.SET_EXPECTED_NEXT_STEP]: (state, expectedNextStep) => {
        Vue.set(state, 'expectedNextStep', expectedNextStep);
    },
}
